export const SEASON_TYPE = {
  L: 'L',
  H: 'H',
  S: 'S',
  E: 'E',
  N: 'N'
}
